import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Register from '../Register/Register';
import './UsuariosData.css';
const roleLabels = {
    usuario: 'Cliente',
    cliente: 'Cliente',
    admin: 'Admin',
};

const escapeSwalValue = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

export default function UsuariosData() {
    const [usuarios, setUsuarios] = useState([]);
    const [filtroIdUsuario, setFiltroIdUsuario] = useState('');
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroFechaDesde, setFiltroFechaDesde] = useState('');
    const [filtroFechaHasta, setFiltroFechaHasta] = useState('');
    const [filtroEmail, setFiltroEmail] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [activeGroup, setActiveGroup] = useState('clientes');

    useEffect(() => {
        cargarUsuarios();
    }, []);

    const cargarUsuarios = async () => {
        try {
            const response = await fetch(`${baseURL}/usuariosGet.php`, {
                method: 'GET',
            });
            const data = await response.json();

            if (!response.ok || data.error) {
                throw new Error(data.error || 'No se pudo cargar la lista de usuarios.');
            }

            if (!Array.isArray(data.usuarios)) {
                throw new Error('La respuesta de usuarios no tiene el formato esperado.');
            }

            setUsuarios(data.usuarios);
        } catch (error) {
            console.error('Error al cargar usuarios:', error);
            toast.error(error.message || 'No se pudo cargar la lista de usuarios.');
        }
    };

    const eliminarUsuario = (idUsuario) => {
        if (!idUsuario) {
            Swal.fire('Error', 'No se encontro el ID del usuario.', 'error');
            return;
        }

        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#780576',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${baseURL}/usuariosGet.php?idUsuario=${encodeURIComponent(idUsuario)}`, {
                        method: 'DELETE',
                    });

                    const data = await response.json();

                    if (!response.ok || data.error) {
                        throw new Error(data.error || 'No se pudo eliminar el usuario.');
                    }

                    Swal.fire(
                        '¡Eliminado!',
                        data.mensaje || 'Usuario eliminado correctamente',
                        'success'
                    );
                    cargarUsuarios();
                } catch (error) {
                    console.error('Error al eliminar usuario:', error);
                    Swal.fire(
                        'Error',
                        error.message || 'No se pudo eliminar el usuario.',
                        'error'
                    );
                }
            }
        });
    };

    const editarUsuario = (usuario) => {
        Swal.fire({
            title: 'Editar usuario',
            html: `
                <input id="swal-nombre" class="swal2-input" placeholder="Nombre" value="${escapeSwalValue(usuario.nombre)}">
                <input id="swal-email" class="swal2-input" placeholder="Email" value="${escapeSwalValue(usuario.email)}">
                <input id="swal-telefono" class="swal2-input" placeholder="Telefono" value="${escapeSwalValue(usuario.telefono)}">
                <input id="swal-direccion" class="swal2-input" placeholder="Direccion" value="${escapeSwalValue(usuario.direccion)}">
                <input id="swal-contrasena" class="swal2-input" type="password" placeholder="Nueva clave (opcional)">
                <select id="swal-rol" class="swal2-select">
                    <option value="cliente" ${(usuario.rol === 'usuario' || usuario.rol === 'cliente') ? 'selected' : ''}>Cliente</option>
                    <option value="admin" ${usuario.rol === 'admin' ? 'selected' : ''}>Admin</option>
                </select>
            `,
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
            focusConfirm: false,
            customClass: {
                popup: 'usuariosEditPopup',
                htmlContainer: 'usuariosEditBody',
            },
            preConfirm: () => {
                const popup = Swal.getPopup();
                const nombre = popup.querySelector('#swal-nombre')?.value?.trim() || '';
                const email = popup.querySelector('#swal-email')?.value?.trim() || '';
                const telefono = popup.querySelector('#swal-telefono')?.value?.trim() || '';
                const direccion = popup.querySelector('#swal-direccion')?.value?.trim() || '';
                const contrasena = popup.querySelector('#swal-contrasena')?.value || '';
                const rol = popup.querySelector('#swal-rol')?.value || 'cliente';

                if (!nombre || !email) {
                    Swal.showValidationMessage('Nombre y email son obligatorios.');
                    return false;
                }

                if (contrasena && contrasena.length < 6) {
                    Swal.showValidationMessage('La nueva clave debe tener al menos 6 caracteres.');
                    return false;
                }

                return {
                    nombre,
                    email,
                    telefono,
                    direccion,
                    contrasena,
                    rol,
                };
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${baseURL}/usuariosGet.php?idUsuario=${encodeURIComponent(usuario.idUsuario)}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(result.value),
                    });
                    const data = await response.json();

                    if (!response.ok || data.error) {
                        throw new Error(data.error || 'No se pudo editar el usuario.');
                    }

                    Swal.fire(
                        'Editado!',
                        data.mensaje || 'Usuario actualizado correctamente',
                        'success'
                    );
                    cargarUsuarios();
                } catch (error) {
                    console.error('Error al editar el usuario:', error);
                    toast.error(error.message || 'No se pudo editar el usuario.');
                }
            }
        });
    };

    const usuariosFiltrados = usuarios.filter(usuario => {
        const idUsuarioMatch = usuario.idUsuario.toString().includes(filtroIdUsuario);
        const nombreMatch = usuario.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
        const fechaDesdeMatch = !filtroFechaDesde || new Date(usuario.createdAt) >= new Date(filtroFechaDesde);
        const fechaHastaMatch = !filtroFechaHasta || new Date(usuario.createdAt) <= new Date(filtroFechaHasta);
        const emailMatch = usuario.email.toLowerCase().includes(filtroEmail.toLowerCase());

        return idUsuarioMatch && nombreMatch && fechaDesdeMatch && fechaHastaMatch && emailMatch;
    });
    const clientesFiltrados = usuariosFiltrados.filter((usuario) => usuario.rol === 'usuario' || usuario.rol === 'cliente');
    const adminsFiltrados = usuariosFiltrados.filter((usuario) => usuario.rol === 'admin');
    const usuariosVisibles = activeGroup === 'admins' ? adminsFiltrados : clientesFiltrados;
    const getRoleLabel = (role) => roleLabels[role] || role;

    const descargarExcel = () => {
        const data = usuariosVisibles.map(usuarios => ({

            'ID Usuario': usuarios.idUsuario,
            Nombre: usuarios.nombre,
            Email: usuarios.email,
            Telefono: usuarios.telefono || '',
            Direccion: usuarios.direccion || '',
            Rol: getRoleLabel(usuarios.rol),
            Fecha: usuarios.createdAt,

        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Usuarios');
        XLSX.writeFile(wb, 'usuarios.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF();
        pdf.text('Lista de Usuarios', 10, 10);

        const columns = [

            { title: 'ID Usuario', dataKey: 'idUsuario' },
            { title: 'Nombre', dataKey: 'nombre' },
            { title: 'Email', dataKey: 'email' },
            { title: 'Telefono', dataKey: 'telefono' },
            { title: 'Direccion', dataKey: 'direccion' },
            { title: 'Rol', dataKey: 'rol' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        const data = usuariosVisibles.map(usuarios => ({

            idUsuario: usuarios.idUsuario,
            nombre: usuarios.nombre,
            email: usuarios.email,
            telefono: usuarios.telefono || '',
            direccion: usuarios.direccion || '',
            rol: getRoleLabel(usuarios.rol),
            createdAt: usuarios.createdAt,
        }));

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('usuarios.pdf');
    };
    const recargarUsuarios = () => {
        cargarUsuarios();
    };
    const invertirOrden = () => {
        setUsuarios([...usuarios].reverse());
        setOrdenInvertido(!ordenInvertido);
    };
    return (
        <div>
            <div className='deFlexContent'>
                <div className='deFlex2'>
                    <Register onSuccess={cargarUsuarios} />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>

                </div>


                <div className='filtrosContain'>
                    <div className='usuariosTabs'>
                        <button type='button' className={activeGroup === 'clientes' ? 'active' : ''} onClick={() => setActiveGroup('clientes')}>
                            Clientes ({clientesFiltrados.length})
                        </button>
                        <button type='button' className={activeGroup === 'admins' ? 'active' : ''} onClick={() => setActiveGroup('admins')}>
                            Admins ({adminsFiltrados.length})
                        </button>
                    </div>
                    <div className='inputsColumn'>

                        <input type="number" value={filtroIdUsuario} onChange={(e) => setFiltroIdUsuario(e.target.value)} placeholder='ID Usuario' />
                    </div>

                    <div className='inputsColumn'>

                        <input type="text" value={filtroNombre} onChange={(e) => setFiltroNombre(e.target.value)} placeholder='Nombre' />
                    </div>
                    <div className='inputsColumn'>

                        <input type="text" value={filtroEmail} onChange={(e) => setFiltroEmail(e.target.value)} placeholder='Email' />
                    </div>

                    <button className='reload' onClick={recargarUsuarios}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>


                </div>
            </div>


            <div className='table-container'>

                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID Usuario</th>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Telefono</th>
                            <th>Direccion</th>
                            <th>Rol</th>
                            <th>Fecha Creación</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuariosVisibles.map(usuario => (
                            <tr key={usuario.idUsuario}>
                                <td>{usuario.idUsuario}</td>
                                <td>{usuario.nombre}</td>
                                <td>{usuario.email}</td>
                                <td>{usuario.telefono || '-'}</td>
                                <td>{usuario.direccion || '-'}</td>
                                <td style={{
                                    color: usuario?.rol === 'usuario' || usuario?.rol === 'cliente' ? '#DAA520' : usuario?.rol === 'admin' ? '#008000' : '#FF0000',

                                }}>  {getRoleLabel(usuario?.rol)}</td>
                                <td>{usuario.createdAt}</td>
                                <td>

                                    <button className='eliminar' onClick={() => eliminarUsuario(usuario.idUsuario)}><FontAwesomeIcon icon={faTrash} /></button>

                                    <button className='editar' onClick={() => editarUsuario(usuario)}><FontAwesomeIcon icon={faEdit} /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>
    );
};
